const POSTHOG_KEY = 'phc_rfm2uNuNFAME84ePgEe5rbYUo6ZmvNf6ELtf8gGvp8z9';

let analyticsClientPromise = null;
let analyticsHasConsent = false;

const getConsentConfig = (hasConsent) => ({
  persistence: hasConsent ? 'localStorage+cookie' : 'memory',
  person_profiles: hasConsent ? 'identified_only' : 'never',
});

export const initializeAnalytics = (hasConsent = analyticsHasConsent) => {
  analyticsHasConsent = hasConsent;

  if (!analyticsClientPromise) {
    analyticsClientPromise = import('posthog-js')
      .then(({ default: posthog }) => {
        posthog.init(POSTHOG_KEY, {
          api_host: 'https://eu.i.posthog.com',
          ...getConsentConfig(analyticsHasConsent),
          capture_pageview: true,
          capture_pageleave: true,
        });

        return posthog;
      })
      .catch((error) => {
        analyticsClientPromise = null;
        throw error;
      });
  }

  return analyticsClientPromise;
};

export const setAnalyticsConsent = (hasConsent) => {
  analyticsHasConsent = hasConsent;

  if (analyticsClientPromise) {
    analyticsClientPromise
      .then((posthog) => posthog.set_config(getConsentConfig(analyticsHasConsent)))
      .catch(() => {});
  }
};
